module.exports = __webpack_public_path__ + "img/global-edit.b9cb1b0a.svg";